/**
 * One-level copying is sufficient as mutations within our `partialTree` are limited to properties
 * such as `.status`, `.cached`, `.nextPagePath`, and not `.data = { THIS }`.
 */
const shallowClone = (partialTree) => {
    return partialTree.map((item) => ({ ...item }));
};
export default shallowClone;
